import { ReactElement } from 'react';
import { Component as ExitIcon } from 'icons/icon-circle-lime--exit.svg';
import { Component as CheckIcon } from 'icons/icon-circle-lime--check.svg';
import { Component as CelebrationIcon } from 'icons/icon-circle-lime--celebration.svg';
import { Component as CartIcon } from 'icons/icon-circle-lime--add-to-cart.svg';
import { Notification } from './Notification';
import { useNotification } from '../../../contexts/NotificationContext';

interface Props {
  variant: ToastVariant,
  date?: string;
}

export enum ToastVariant {
  CART_SAVED = 'cart_saved',
  CART_SKIPPED = 'cart_skipped',
  CART_UNSKIPPED = 'cart_unskipped',
  ACCOUNT_ACTIVE = 'account_activated',
  CART_FREE_SHIPPING_UNLOCKED = 'cart_free_shipping_unlocked',
  CART_UNSKIPPED_AND_ADDED = 'cart_unskipped_and_added',
  ITEM_ADDED_TO_CART = 'item_added_to_cart',
  WELCOME_PREFILLED_CART = 'welcome_prefilled_cart',
}

export function Toast({
  variant,
  date,
}: Props): ReactElement {
  const { hideNotification } = useNotification();

  const modalContent = {
    [ToastVariant.CART_UNSKIPPED]: {
      notificationText: 'Your order is unskipped.',
      notificationIcon: CelebrationIcon,
      onClose: hideNotification,
      onClick: undefined,
    },
    [ToastVariant.ACCOUNT_ACTIVE]: {
      notificationText: 'Your account is now active!',
      notificationIcon: CelebrationIcon,
      onClose: hideNotification,
      onClick: undefined,
    },
    [ToastVariant.CART_SKIPPED]: {
      notificationText: 'Your order is skipped.',
      notificationIcon: ExitIcon,
      onClose: hideNotification,
      onClick: undefined,
    },
    [ToastVariant.CART_SAVED]: {
      notificationText: date ? `Your ${date} cart is saved.` : 'Your order is saved.',
      notificationIcon: CheckIcon,
      onClose: hideNotification,
      onClick: undefined,
    },
    [ToastVariant.CART_FREE_SHIPPING_UNLOCKED]: {
      notificationText: 'You’ve unlocked free shipping!',
      notificationIcon: CelebrationIcon,
      onClose: hideNotification,
      onClick: undefined,
    },
    [ToastVariant.CART_UNSKIPPED_AND_ADDED]: {
      notificationText: 'Added to cart! Order is unskipped.',
      notificationIcon: CelebrationIcon,
      onClose: hideNotification,
      onClick: undefined,
    },
    [ToastVariant.ITEM_ADDED_TO_CART]: {
      notificationText: 'Item added to your cart.',
      notificationIcon: CartIcon,
      onClose: hideNotification,
      onClick: undefined,
    },
    [ToastVariant.WELCOME_PREFILLED_CART]: {
      notificationText: 'Welcome! Your cart\'s been pre-filled with our chef\'s weekly picks to get you started.',
      notificationIcon: CartIcon,
      onClose: hideNotification,
      onClick: undefined,
    },
  };
  return (
    <>
      <Notification
        icon={modalContent[variant].notificationIcon}
        text={modalContent[variant].notificationText}
        onClose={modalContent[variant].onClose}
        onClick={modalContent[variant].onClick}
      />
    </>
  );
}
